import { settled } from 'common/types/Event-type.type';

export const EVENTS_TO_REFETCH_COMPANY_UPDATES = [
  settled('CompanyUpdateAdded'),
  settled('CompanyUpdateUpdated'),
  settled('CompanyUpdateDeleted'),
];
